interface Props {
  aggregates: { teasers: number; ndas: number; cims: number; iois: number; lois: number };
}

function pct(n: number, d: number) { return d > 0 ? Math.round((n / d) * 100) : 0; }

export function TrackerHeadline({ aggregates: a }: Props) {
  const cards = [
    { label: "Teasers Sent", value: a.teasers, sub: `${a.ndas} NDAs signed · ${pct(a.ndas, a.teasers)}%`, bar: pct(a.ndas, a.teasers), color: "#2563eb" },
    { label: "CIMs Sent", value: a.cims, sub: `of ${a.ndas} NDAs · ${pct(a.cims, a.ndas)}%`, bar: pct(a.cims, a.ndas), color: "#0ea5e9" },
    { label: "IOIs Received", value: a.iois, sub: `of ${a.cims} CIMs · ${pct(a.iois, a.cims)}%`, bar: pct(a.iois, a.cims), color: "#14b8a6" },
    { label: "LOIs Received", value: a.lois, sub: `of ${a.iois} IOIs · ${pct(a.lois, a.iois)}%`, bar: pct(a.lois, a.iois), color: "#16a34a" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      {cards.map((c) => (
        <div key={c.label} className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-900">
          <div className="flex items-center justify-between">
            <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{c.label}</span>
            <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.color }} />
          </div>
          <div className="mt-1.5 text-3xl font-bold tabular-nums leading-none text-slate-900 dark:text-slate-200">{c.value}</div>
          <div className="mt-2 text-xs text-slate-500">{c.sub}</div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-900/30">
            <div className="h-full" style={{ width: `${c.bar}%`, background: c.color }} />
          </div>
        </div>
      ))}
    </div>
  );
}
